/**
 * `Object.hasOwn` n'est pas disponible dans la cible ES de ce package partagé : un seul helper
 * interne (non réexporté par `index.ts`) pour tous les parseurs qui refusent les clés héritées du
 * prototype (`constructor`, `__proto__`…).
 */
export const hasOwn = (value: object, key: PropertyKey): boolean =>
  Reflect.getOwnPropertyDescriptor(value, key) !== undefined
